import { useEffect, useMemo, useState } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getCreditNoteColumns } from './CreditNoteFields'
import Loading from '../../common/Loading'
import CreditNote from './CreditNote'
import DocumentPreview from '../../document/DocumentPreview'

const ListCreditNote = () => {
  const [statusList, setStatusList] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statusListRes, customersRes] = await Promise.all([
          getObjectsWithFilter('status', { object: 'creditNotes' }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setStatusList(Array.isArray(statusListRes.data) ? statusListRes.data : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!statusList.length || !customers.length) return []
    return getCreditNoteColumns({ statusList, customers })
  }, [statusList, customers])

  const objectFilter = useMemo(() => ({ company_id: user.company_id }), [user.company_id])

  const options = useMemo(
    () => ({
      objectType: 'creditNotes',
      accessRight: userRight,
      objectFilter: () => objectFilter,
      actions: {
        add: true,
        edit: true,
        editDisabled: (creditNote) => creditNote.status >= 70,
        view: true,
        delete: {
          message: "Voulez-vous vraiment supprimer l'avoir",
          field: 'creditNote_number'
        }
      },
      isFilter: true,
      isExpand: true,
      defaultSorted: 'creditNote_number',
      expand: (row) => <DocumentPreview Component={CreditNote} document={row} />,
      columns
    }),
    [userRight, user.company_id, columns]
  )
  const toolbar = useMemo(
    () => ({
      objectType: 'creditNotes',
      title: 'Avoirs',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  if (!columns.length) return <Loading />

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListCreditNote
